import React from "react";
import { useTranslation } from "react-i18next";
import { FaAngleUp, FaAngleDown, FaRegClone, FaTrash } from "react-icons/fa6";
import { TbRectangle, TbCircle, TbTriangle, TbLine, TbPointFilled, TbTypography, TbAngle } from "react-icons/tb";
import { CanvasPrimitiveType } from "@ltypes/scene";
import { EditorPrimitive, resolveLabel } from "./primitives";

const ICONS: Record<CanvasPrimitiveType, React.ReactNode> = {
    text: <TbTypography size="1.1rem" />,
    rectangle: <TbRectangle size="1.1rem" />,
    circle: <TbCircle size="1.1rem" />,
    line: <TbLine size="1.1rem" />,
    triangle: <TbTriangle size="1.1rem" />,
    arc: <TbAngle size="1.1rem" />,
    pixel: <TbPointFilled size="1.1rem" />,
};

type LayersPanelProps = {
    primitives: Array<EditorPrimitive>,
    selectedId: string | null,
    onSelect: (id: string) => void,
    onRaise: (id: string) => void,
    onLower: (id: string) => void,
    onDuplicate: (id: string) => void,
    onDelete: (id: string) => void,
};

function LayersPanel(props: LayersPanelProps) {
    const { t } = useTranslation();

    // Top of the stack (last painted) shown first.
    const ordered = [...props.primitives].reverse();

    return (
        <div className="canvas-layers">
            <div className="canvas-layers-title">{t('page.scenes.canvas.layers')}</div>
            {ordered.length === 0 ? (
                <div className="canvas-layers-empty">{t('page.scenes.canvas.layers_empty')}</div>
            ) : (
                <ul className="canvas-layers-list">
                    {ordered.map((p) => (
                        <li
                            key={p._id}
                            className={`canvas-layers-item ${props.selectedId === p._id ? 'active' : ''}`}
                            onClick={() => props.onSelect(p._id)}
                        >
                            <span className="canvas-layers-item-swatch" style={{ background: p.color }} />
                            <span className="canvas-layers-item-icon">{ICONS[p.type]}</span>
                            <span className="canvas-layers-item-label">{resolveLabel(p, t(`page.scenes.canvas.tool.${p.type}`))}</span>
                            <span className="canvas-layers-item-actions">
                                <button type="button" title={t('page.scenes.canvas.raise')} onClick={(e) => { e.stopPropagation(); props.onRaise(p._id); }}><FaAngleUp size="0.9rem" /></button>
                                <button type="button" title={t('page.scenes.canvas.lower')} onClick={(e) => { e.stopPropagation(); props.onLower(p._id); }}><FaAngleDown size="0.9rem" /></button>
                                <button type="button" title={t('page.scenes.canvas.duplicate')} onClick={(e) => { e.stopPropagation(); props.onDuplicate(p._id); }}><FaRegClone size="0.9rem" /></button>
                                <button type="button" className="danger" title={t('page.scenes.canvas.delete')} onClick={(e) => { e.stopPropagation(); props.onDelete(p._id); }}><FaTrash size="0.9rem" /></button>
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default LayersPanel;
